import React from 'react'
import ForgotPasswordForm from './ForgotPassword'

const ForgotPassword = ({resetPassword, shouldResetPassword, setShouldResetPassword, location}) => (
  <ForgotPasswordForm
    resetPassword={resetPassword}
    shouldResetPassword={shouldResetPassword}
    setShouldResetPassword={setShouldResetPassword}
    location={location}/>
)

export default ForgotPassword



// WEBPACK FOOTER //
// src/components/ForgotPassword/index.js